module.exports = __webpack_public_path__ + "static/media/f1.0adac922.png";